export const endpoint = {
	base: "",
	jobId: "/:jobId",
	save: "/save/:jobId",
	fix: "/fix/:jobId",
} as const;
